import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const editAtmModel = ( {data, atmModelId} : {data: IPostEditAtmModel | {}, atmModelId: number}): Promise<string> => {
  return axiosDefaultApi.put(`/api/AtmModels/UpdateAtmModel/${atmModelId}`, data);
};

type QueryFnType = typeof editAtmModel;

type UseEditAtmModelOptions = {
  data: IPostEditAtmModel | {};
  atmModelId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditAtmModel = ({ config }: UseEditAtmModelOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία του Μοντέλου.`, 500);
            console.error('Couldnt edit AtmModel', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllAtmModels"])
            addNotification('Το Μοντέλο Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editAtmModel,
    })
}